<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-select class="full-width" multiple clearable v-model="valueSync" filterable :placeholder="placeholder">
        <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.name"
                :value="item.value"
        >
        </el-option>
    </el-select>
</template>

<script>
    import {items, defaultItems} from '@/constant/enroll_items';

    export default {
        name: '',
        props: {
            placeholder: {
                type: String,
                default: '请选择报名必填项目'
            },
            value: {
                type: Array
            }
        },
        computed: {
            options () {
                return items;
            }
        },
        data () {
            return {
                valueSync: []
            };
        },
        watch: {
            value (value) {
                this.valueSync = value || [];
            },
            valueSync (valueSync) {
                if (valueSync === '' || valueSync === null) {
                    this.valueSync = [];
                    return;
                }
                this.$emit('input', valueSync);
            }
        }
    };
</script>
